<template>
  <div class="rcv2MainDiv">
    <split-pane v-on:resize="resize" :min-percent='0' :default-percent='25' :max-percent='50' split="vertical">
      <template slot="paneL">
        <div style="margin-top: 0;overflow: hidden;height: 100%;">
          <template>
            <resource-page-tree :tree-data="tableData" v-on:treeInfo="treeInfo" :directory-id="directoryId"></resource-page-tree>
          </template>
        </div>
      </template>
      <template slot="paneR">
        <div style="height: calc(50% - 5px);">
          <el-table
            ref="listTable"
            @current-change="currentChanged"
            highlight-current-row
            :data="finalChildTableData"
            v-loading="fullscreenLoading"
            :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
            style="width: 100%;"
            height="100%"
            row-key="id"
            size="mini"
            border>
            <el-table-column align="left" prop="object.key.name" label="表名" sortable>
            </el-table-column>
            <el-table-column align="left" prop="object.key.useName" label="创建人" width="90" sortable>
            </el-table-column>
            <el-table-column align="left" prop="object.key.testStatus" label="状态" width="70" sortable :formatter="formatter">
            </el-table-column>
            <el-table-column align="center" prop="object.key.signDate" label="录入日期" width="135">
            </el-table-column>
            <el-table-column style="height:30px;" fixed="right" label="操作" align="center" width="50">
              <template slot-scope="scope">
                <template v-if="!scope.row.attributes">
                  <el-tooltip v-if="scope.row.object.key.storageType !== '1'" content="查看" placement="top">
                    <el-button size="mini" type="primary" icon="el-icon-view" @click="viewRow(scope.row)" circle plain></el-button>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="height: 50%; margin-top: 5px;">
          <el-tabs v-model="activeName" type="card" slot="paneR" style="height: 100%;">
            <el-tab-pane v-if="false" label="附录资料" name="first" style="height: 100%;">
              <div style="height:100%;">
                <el-table ref="listTable2"
                          highlight-current-row
                          :data="setTableData"
                          :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                          height="100%" style="width: 100%;" row-key="id" border size="mini">
                  <el-table-column align="left" prop="object.key.name" label="表名" min-width="250" sortable>
                  </el-table-column>
                  <el-table-column align="left" prop="object.key.useName" label="创建人" width="90" sortable>
                  </el-table-column>
                  <el-table-column align="left" prop="object.key.testStatus" label="状态" width="70" sortable :formatter="formatter">
                  </el-table-column>
                  <el-table-column align="left" prop="object.key.signDate" label="录入日期" width="85">
                  </el-table-column>
                  <el-table-column style="height:30px;" fixed="right" label="操作" align="center" width="50">
                    <template slot-scope="scope">
                      <template v-if="!scope.row.attributes">
                        <el-tooltip v-if="scope.row.object.key.storageType !== '1'" content="查看" placement="top">
                          <el-button size="mini" type="primary" icon="el-icon-view" @click="viewRow(scope.row)" circle plain></el-button>
                        </el-tooltip>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="附件" name="first" style="height: 100%;">
              <el-table
                :data='attachmentList'
                border
                stripe
                highlight-current-row
                :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                height="100%"
                size="mini">
                <el-table-column fixed type="index" label=" ">
                </el-table-column>
                <template v-for="item in attachmentColumns">
                  <el-table-column :key="item.dataIndex" :prop="item.dataIndex" :label="item.title" align="center" sortable :min-width="item.width" show-overflow-tooltip>
                  </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" align="center" width="95">
                  <template slot-scope="scope">
                    <el-tooltip v-if="isView(scope.row)" content="预览" placement="top">
                      <el-button size="mini" type="primary" icon="el-icon-view" @click="attachmentViewRow(scope.row)" circle plain></el-button>
                    </el-tooltip>
                    <el-tooltip content="下载" placement="top">
                      <el-button size="mini" type="info" icon="el-icon-download" @click="downloadRow(scope.row)" circle plain></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </split-pane>
  </div>
</template>

<script>
  import ResourcePageTree from "./ResourcePageTree";
  import markLabel from "./flowStatus";
  import {
    search,
    getQualityTempListFile,
    getQualityListFile,
    getQualityDatumListApi} from "../../api/processApproval";

  const attachmentColumns = [
    {
      title: "文件名",
      dataIndex: "originalName",
      width: "40%"
    },
    {
      title: "文件大小(B)",
      dataIndex: "length",

      width: "25%"
    },
    {
      title: "文件类别",
      dataIndex: "extName",
      width: "20%"
    }
  ];
  export default {
    name: "RelatedConstructionView2",
    components: {ResourcePageTree},
    props: {
      projectId: {
        type: String,
        default: "",
        required: true
      },
      sectionId: {
        type: String,
        default: "",
        required: true
      },
      prjCode: {
        type: String,
        default: "",
      },
      sectionCode: {
        type: String,
        default: "",
      },
      useCompany: {
        type: String,
        default: "",
        required: true
      },
      templeId: {
        type: String,
        default: "",
      },
      directoryId: {
        type: String,
        default: ''
      },
      qualityInstId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        markLabel,
        currentData: null,
        attachmentColumns,
        fullscreenLoading: false,
        attachmentList: [],
        childTableData: [],
        finalChildTableData: [],
        tableSelection: [],
        tableData: [],
        setTableData: [],
        treeNode: {},
        activeName: 'first',
        partId: '',
        record: {},
        docPath:`http://${window.location.hostname}:${window.location.port}/qualityData/workFlow/`,
        docPath2:`http://${window.location.hostname}:${window.location.port}/loleaflet/dist/loleaflet.html?WOPISrc=http://${window.location.hostname}:${window.location.port}/api/develop/wopi/files/`,
      }
    },
    methods: {
      resize() {
        if (this.$children[0].percent > 50) {
          this.$children[0].percent = 50;
        }
      },
      currentChanged(row) {
        if (row == null) {
          return;
        }
        this.record = row;

        this.attachmentList = [];
        this.setTableData = [];
        if(!!row.object.key.storageType && row.object.key.storageType === '1'){
          //附件
          this.record.ID = row.object.key.id
          this.fetchAttachment(row.object.key.id);
        }else{
          this.record.ID = row.object.key.instId
          this.fetchAttachment(row.object.key.instId);
        }

        this.getSetTableData();
      },
      //获取附录资料
      getSetTableData() {
        let params = {
          numId: this.record.object.key.numId,
          pid: this.treeNode.id
        };
        getQualityTempListFile(this.$qs.stringify(params)).then(response => {
          if (response.success) {
            var result = []
            response.data.forEach(row => {
              result.push({id: row.numId, object:{key:row}})
            });

            this.setTableData = [...result];
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error(error.toString);
        });
      },
      treeInfo(node) {
        this.treeNode = node;
        if(!node){
          //清空
          this.childTableData = null;
          return
        }

        let item = this.currentData;
        var params = {
          partCode: item.id,
          partType: item.type,
          partTypeCode: item.projectTypeCode,
          projectId: this.projectId, //'109210453904719872',
          type: !!item.bim ? item.bim : "",
          mainId: node.id ? node.id : '',
          useCompany: this.useCompany
        };
        if (node.attributes.orderNo === node.attributes.code) {//套表目录
          params.code = node.attributes.code
        }

        this.fullscreenLoading = true;
        getQualityListFile(this.$qs.stringify(params)).then(response => {
          if (response.success) {
            this.attachmentList = [];
            this.setTableData = [];

            var result = [];
            response.data.forEach(row => {
              result.push({id: row.numId, object:{key:row}})
            });

            this.fullscreenLoading = false;
            this.finalChildTableData = [...result];

            if (this.finalChildTableData.length > 0) {
              this.$nextTick(() => {
                var selected = false;
                if (this.qualityInstId) {
                  this.finalChildTableData.forEach(row => {
                    if (this.qualityInstId == row.object.key.instId) {
                      this.$refs.listTable.setCurrentRow(row);
                      selected = true;
                    }
                  })
                }

                if (!selected) {
                  this.$refs.listTable.setCurrentRow(this.finalChildTableData[0]);
                }
              });
            }
          } else {
            this.fullscreenLoading = false;
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.fullscreenLoading = false;
          this.$message.error(error.toString);
        });
      },
      // 模板列表
      getQualityInspectionDataTableData(item) {
        this.currentData = item;
        this.tableData = [];
        this.childTableData = [];
        this.finalChildTableData = [];
        this.setTableData = [];
        this.attachmentList = [];
        var params = {
          partCode: item.id,
          partType: item.type,
          partTypeCode: item.projectTypeCode,
          projectId: this.projectId, //'109210453904719872',
          type: !!item.bim ? item.bim : "",
          useCompany: this.useCompany
        };

        this.partId = item.id;
        this.fullscreenLoading = true;
        getQualityDatumListApi(this.$qs.stringify(params))
          .then(result => {
            this.fullscreenLoading = false;
            if (result.success) {
              this.tableData = [...result.data];
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            this.fullscreenLoading = false;
            this.$message.error(error.toString);
          });
      },
      formatter(row, column, cellValue, index) {
        if (!!row.attributes) {
          return cellValue;
        }
        const ix = row.object.key;
        let testText = "未填写";
        if (ix.hasOwnProperty("instId") && ix.instId !== "") {
          if (ix.hasOwnProperty("testStatus")) {
            switch (ix.testStatus) {
              case "1": //未提交
                testText = "未提交";
                ix.color = this.markLabel[3].color;
                ix.enableCopy = true;
                break;
              case "2": //被退回
                testText = "被退回";
                ix.color = this.markLabel[2].color;
                break;
              case "3": //流转中
                testText = "流转中";
                ix.color = this.markLabel[1].color;
                break;
              case "4": //已通过
                testText = "已通过";
                ix.color = this.markLabel[0].color;
                break;
              default:
                ix.color = this.markLabel[4].color;
                break;
            }
          }
        } else {
          ix.color = this.markLabel[4].color;
        }
        if (!!ix.storageType && ix.storageType == "1") {
          //附件自动设置为通过
          if (!!ix.testStatus && ix.testStatus == "4") {
            ix.color = this.markLabel[0].color;
            testText = "已通过";
          } else {
            ix.color = this.markLabel[4].color;
          }
        }
        return <span style={{ color: ix.color }}>{testText}</span>;
      },
      viewRow(row) {
        if (!!row.object.key.instId) {
          window.open(this.docPath + row.object.key.instId);
        } else {
          let url = `${this.docPath2}${row.object.key.excelId}&access_token=${row.object.key.excelId}`;
          window.open(url);
        }
      },
      isView(row){
        return ['xls','pdf','jpg','jpeg','png','gif','xlsx','doc','docx','txt'].some(item => item === row.extName)
      },
      attachmentViewRow(row) {
        window.open(`/api/fs/files/view?metaData.formId=${row.metaData.formId}&id=${row.id}`)
      },
      downloadRow(row) {
        window.open(`/api/fs/files/download/${row.id}?asAttachment=true`);
      },
      fetchAttachment(formId) {
        if (!formId) { return; }
        search(formId).then(data => {
          this.attachmentList = data;
        });
      },
      updateData() {
        if (!!this.currentData) {
          this.getQualityInspectionDataTableData(this.currentData);
        }
      }
    }
  }
</script>

<style scoped>
  .rcv2MainDiv {
    width: 100%;
    height: 80vh;
  }
</style>

<style>
  .rcv2MainDiv .el-table th {
    padding: 4px 0;
  }

  .rcv2MainDiv .el-tabs__header {
    margin: 0;
  }
  .rcv2MainDiv .el-tabs__content {
    height: -webkit-calc(100% - 41px);
    height: calc(100% - 41px);
  }
</style>



// WEBPACK FOOTER //
// src/components/todo/RelatedConstructionView2.vue